// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slurry-details-container {
  padding: 1rem;
  min-height: 100vh;
}
.slurry-loading-wrap {
  min-height: calc(100vh - 2rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.slurry-saving-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  cursor: wait;
}

div.tabbed > ul.tabs > li.active-tab {
  color: #0b2d71 !important;
  font-weight: 600;
  border-bottom: 4px solid #0b2d71;
  padding-bottom: 0;
}

div.tabbed > ul.tabs {
  margin: 0;
  padding: 0;
  text-align: left;
}

/* Breadcrumb parity with Slurry */
.breadcrumb-row {
  font-size: 13px;
  margin-bottom: 10px;
  color: #6B6D6F;
}
.breadcrumb-link {
  color: #0066B2;
  cursor: pointer;
  text-decoration: underline;
}
.breadcrumb-link:hover { color: #004080; }
.breadcrumb-sep { margin: 0 4px; color: #888; }
.breadcrumb-current { color: #333; font-weight: 600; }

/* Read-only shell used for info tab parity without adding extra visual wrappers. */
.surface-tab-stack[inert] {
  opacity: 0.85;
}

/* ── Section blocks (navy header + white body) ── */
.section {
  background: white;
  border: 1px solid #cdd8e3;
  margin-bottom: 10px;
}
.section-header {
  background: #0b2d71;
  border-bottom: 1px solid #0b2d71;
  padding: 6px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section-title {
  font-weight: 600;
  color: #fff;
  font-size: 15px;
}
.warning-icon {
  background: #E5601F;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* ── Section body padding ── */
.surface-section-body {
  padding: 12px;
}

.surface-top-fields {
  margin-bottom: 6px;
}

.surface-tab-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.surface-tab-stack .tests-section {
  margin-bottom: 0;
}

.surface-divider {
  border-top: 1px solid #d6d8db;
  margin: 8px 0 16px;
}

.surface-notes-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.surface-notes-actions {
  display: flex;
  justify-content: flex-end;
}

/* ── Delete button ── */
.delete-btn {
  color: #c0392b;
  font-size: 18px;
  border: none;
  background: transparent;
  cursor: pointer;
}

/* ── Footer actions ── */
.footer-actions {
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
}
.footer-actions-main {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.footer-actions-left,
.footer-actions-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.footer-actions-right {
  margin-left: auto;
}
.single-test-dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 960;
}
.single-test-dialog {
  width: 840px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border: 1px solid #cfd9e3;
  border-radius: 4px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
}
.single-test-dialog-header {
  padding: 14px 16px 8px;
  font-size: 18px;
  font-weight: 700;
  color: #0b2d71;
}
.single-test-dialog-body {
  padding: 4px 16px 16px;
}
.single-test-dialog-field {
  margin-bottom: 0;
}
.single-test-dialog-section {
  margin-top: 12px;
}
.single-test-dialog-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  margin-top: 12px;
}
.single-test-basic-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}
.single-test-dialog-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}
.single-test-dialog-span-2 {
  grid-column: span 2;
}
.single-test-dialog-note-field {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}
.single-test-dialog-note-field > label {
  width: 100%;
}
.single-test-dialog-note-field .tab-input {
  width: 100%;
  max-width: none;
}
.single-test-dialog-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #16355f;
}
.single-test-dialog-message {
  margin-top: 12px;
  color: #b42318;
  font-size: 12px;
}
.single-test-dialog textarea.tab-input {
  min-height: 76px;
  resize: vertical;
}
.single-test-dialog-actions {
  display: flex;
  justify-content: flex-end;
}
.single-test-dialog-footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 16px;
  border-top: 1px solid #d7e0ea;
}
@media (max-width: 900px) {
  .single-test-dialog-grid,
  .single-test-basic-info-grid {
    grid-template-columns: 1fr;
  }

  .single-test-dialog-span-2 {
    grid-column: span 1;
  }

  .single-test-dialog-note-field {
    grid-column: span 1;
  }
}

/* ── Blend / Liquid tables ── */
.blend-section {
  margin: 10px 12px;
}
.blend-header {
  font-weight: 600;
  color: #0b2d71;
  font-size: 12px;
  margin-bottom: 8px;
  padding: 4px 0;
}
.blend-table,
.liquid-table {
  width: 100%;
  font-size: 11px;
  margin-bottom: 8px;
  font-size: 11px;
}
.blend-table thead,
.liquid-table thead {
  background: #e8f4fd;
  border: 1px solid #b8d6ec;
}
.blend-table th,
.liquid-table th {
  padding: 6px 8px;
  text-align: center;
  font-weight: 600;
  color: #0b2d71;
  border: 1px solid #cdd8e3;
  font-size: 11px;
  white-space: nowrap;
}
.blend-table td,
.liquid-table td {
  padding: 2px;
  border: 1px solid #d0d0d0;
  background: white;
  text-align: center;
}
.blend-table td:has(input:not([readonly]), select:not([disabled])),
.liquid-table td:has(input:not([readonly]), select:not([disabled])) {
  background: #fff !important;
}
.blend-table td:has(input:not([readonly]), select:not([disabled])) input:not([readonly]),
.blend-table td:has(input:not([readonly]), select:not([disabled])) select:not([disabled]),
.liquid-table td:has(input:not([readonly]), select:not([disabled])) input:not([readonly]),
.liquid-table td:has(input:not([readonly]), select:not([disabled])) select:not([disabled]) {
  background: #fff;
}
.table-readonly-cell {
  background: #f1f3f5 !important;
}
.blend-table td.table-readonly-cell input[readonly],
.liquid-table td.table-readonly-cell input[readonly],
.blend-table input[readonly],
.liquid-table input[readonly] {
  background: #f1f3f5;
  color: #495057;
}
.col-material { width: 200px; }
.col-numeric  { width: 100px; text-align: center; }
.col-container { width: 180px; }
.blend-base-table td,
.blend-base-table .form-control,
.blend-base-table .numeric-input,
.blend-base-table .container-input {
  text-align: center;
}
.material-cell {
  display: flex;
  align-items: center;
  gap: 5px;
}
.material-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

/* Inline table inputs */
.material-select {
  width: 100%;
  padding: 3px 6px;
  border: 1px solid #aaa;
  font-size: 11px;
  background: white;
}
.material-select.by-weight-select {
  width: 65px;
  padding: 2px 4px;
}
.numeric-input {
  width: 100%;
  padding: 3px 6px;
  border: none;
  font-size: 11px;
  text-align: center;
  box-sizing: border-box;
}
.container-input {
  width: 100%;
  padding: 3px 6px;
  border: none;
  font-size: 11px;
  text-align: center;
  box-sizing: border-box;
}
.table-container-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.table-search-btn {
  flex: 0 0 auto;
  min-width: 42px;
  padding: 2px 6px;
  line-height: 1;
}
.table-edit-btn {
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-edit-btn:disabled {
  cursor: not-allowed;
}
.cispro-display-input {
  background: transparent;
}
.cispro-display-input[readonly] {
  cursor: default;
}
.cispro-disposed-input,
.blend-table input.cispro-disposed-input[readonly],
.liquid-table input.cispro-disposed-input[readonly] {
  border: 2px solid #dc0000;
  border-radius: 3px;
}
.cispro-editor-overlay {
  position: fixed;
  inset: 0;
  background: rgba(7, 22, 44, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 950;
}
.cispro-editor-dialog {
  width: 560px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border: 1px solid #cfd9e3;
  border-radius: 4px;
  box-shadow: 0 18px 40px rgba(9, 30, 66, 0.24);
}
.cispro-editor-header {
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: #0b2d71;
  border-bottom: 1px solid #0b2d71;
}
.cispro-editor-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.cispro-editor-intro {
  color: #49627d;
  font-size: 13px;
}
.cispro-editor-empty-note {
  padding: 10px 12px;
  border: 1px dashed #cfd9e3;
  border-radius: 4px;
  background: #f8fbff;
  color: #5d728a;
  font-size: 12px;
}
.cispro-editor-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cispro-editor-field > label {
  font-size: 12px;
  font-weight: 600;
  color: #16355f;
}
.cispro-editor-row {
  display: grid;
  grid-template-columns: 1fr 40px 40px;
  gap: 8px;
  align-items: center;
}
.cispro-icon-btn {
  width: 40px;
  height: 40px;
  border: 1px solid #cfd9e3;
  border-radius: 4px;
  background: #fff;
  padding: 0;
  font-size: 18px;
  line-height: 1;
  color: #16355f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.cispro-icon-btn:hover {
  background: #f3f7fc;
  border-color: #9fb6d0;
}
.cispro-remove-btn {
  color: #b42318;
}
.cispro-lookup-btn {
  font-size: 20px;
}
.cispro-editor-input {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #b9c5d3;
  border-radius: 4px;
  background: #f8fbff;
  color: #16355f;
}
.cispro-editor-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid #d7e0ea;
}

@media (max-width: 640px) {
  .cispro-editor-row {
    grid-template-columns: 1fr;
  }

  .cispro-editor-footer {
    justify-content: center;
    flex-wrap: wrap;
  }
}

/* ── Test tabs: settings grid, section titles, tables, inputs ── */

/* .form-row / .tab-input are used only inside .test-settings-grid cells
   for compact label-input pairs. They rely on the grid for column layout
   and must NOT be used for main form rows (use Bootstrap row/col there). */
.form-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 4px;
}
.form-row label {
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
  flex-shrink: 0;
}
.tab-input {
  flex: 1;
  min-width: 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  font-family: 'GothamNarrowBook', sans-serif;
}
.tab-input-readonly,
.tab-input[readonly] {
  background: #e9ecef;
  color: #495057;
}

.test-settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 6px 20px;
  margin-bottom: 14px;
}
.tests-section {
  margin-bottom: 14px;
}
.tests-section-header {
  padding-top: 7px;
  padding-bottom: 7px;
}
.tests-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
}
.tests-toggle input {
  margin: 0;
}
.test-row-card {
  border: 1px solid #d7e0ea;
  border-radius: 4px;
  padding: 10px;
  background: #fff;
}
.test-row-card + .test-row-card {
  margin-top: 8px;
}
.legacy-test-card {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(260px, 1fr);
  gap: 12px 24px;
  align-items: start;
}
.legacy-test-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.legacy-test-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px 12px;
  margin-top: 6px;
}
.legacy-test-muted-cell {
  min-width: 0;
}
.legacy-test-muted-cell .test-fixed-row {
  grid-template-columns: minmax(0, 1fr);
  gap: 0;
}
.legacy-test-muted-cell .legacy-test-muted-row {
  margin-bottom: 0;
}
.legacy-test-action-buttons {
  display: flex;
  gap: 8px;
  min-width: 0;
  justify-content: flex-end;
  flex-wrap: wrap;
  grid-column: 2;
}
.legacy-test-muted-label,
.legacy-test-actions .legacy-test-muted-row > label,
.thickening-actions .legacy-test-muted-row > label {
  margin: 0;
  font-weight: 600;
  font-family: 'GothamNarrowBold', sans-serif;
}
.legacy-test-muted-checkbox,
.legacy-test-muted-row > input[type='checkbox'] {
  justify-self: start;
  margin: 0;
}
.legacy-test-muted-row {
  display: grid;
  grid-template-columns: 190px auto;
  align-items: center;
  gap: 8px;
  margin: 0;
}
.legacy-test-muted-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  margin: 0;
  font-weight: 600;
  justify-self: start;
}
.test-checkbox-row {
  grid-template-columns: 190px auto !important;
  gap: 8px !important;
  align-items: center !important;
}
.test-checkbox-row > input[type='checkbox'],
.compressive-checkbox-row > input[type='checkbox'] {
  justify-self: start;
  margin-left: 0;
}
.legacy-test-temperature-row {
  margin-top: -2px;
}
.compressive-test-card {
  grid-template-columns: minmax(0, 1.5fr) minmax(260px, 1fr);
}
.compressive-test-main {
  gap: 10px;
}
.compressive-test-top {
  display: grid;
  grid-template-columns: minmax(240px, 0.95fr) minmax(300px, 1.1fr);
  gap: 18px;
  align-items: start;
}
.compressive-test-meta,
.compressive-test-conditions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}
.compressive-test-type-row {
  grid-template-columns: minmax(0, 190px) minmax(0, 170px) !important;
  gap: 8px !important;
  align-items: center !important;
}
.compressive-checkbox-row {
  grid-template-columns: 190px auto !important;
  gap: 8px !important;
  align-items: center !important;
}
.compressive-parameter-row {
  display: grid;
  grid-template-columns: minmax(0, 190px) minmax(0, 170px) !important;
  gap: 8px;
  align-items: center;
  justify-content: start;
}
.compressive-parameter-row .tab-input {
  width: 100% !important;
  max-width: 170px !important;
  min-width: 0;
  justify-self: stretch;
}
.validated-test-input {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.validated-test-input .tab-input {
  flex: 1 1 auto;
  min-width: 0;
}
.validation-input-invalid {
  border-color: #c62828 !important;
}
.validation-inline-message {
  margin: 0.35rem 0;
  color: #c62828;
  font-size: 0.8rem;
  font-weight: 600;
}
.validation-field-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border-radius: 50%;
  background: #c62828;
  color: #fff;
  font-weight: 700;
  line-height: 1;
}
.compressive-test-type-row > label,
.compressive-parameter-row > label,
.basic-info-field > label {
  min-width: 0;
}
.compressive-notes-row {
  margin-top: 2px;
}
.compressive-notes-row textarea.tab-input {
  min-height: 64px;
  resize: vertical;
}
.test-output-card {
  min-height: 100%;
}
.hpht-group-card,
.other-test-card,
.batch-summary-card,
.batch-editor-card {
  margin-bottom: 10px;
}
.hpht-reading-card + .hpht-reading-card {
  border-top: 1px solid #d7e0ea;
  padding-top: 10px;
}
.hpht-reading-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}
.hpht-readings-label {
  margin: 8px 0 4px;
  font-weight: 600;
}
.foam-settings-action {
  display: flex;
  align-items: center;
}
.batches-create-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.batches-create-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.batches-create-panel {
  display: grid;
  gap: 12px;
}
.batches-test-list {
  display: grid;
  gap: 6px;
  max-width: 420px;
}
.batches-test-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #1c2d41;
}
.batches-test-option input {
  margin: 0;
}
.batches-existing-table-wrap {
  overflow-x: auto;
}
.batches-existing-table {
  width: 100%;
}
.batches-existing-row {
  cursor: pointer;
}
.batches-existing-row td {
  vertical-align: top;
}
.batches-existing-row:hover td {
  background: #f7fafc;
}
.batches-existing-row-selected td {
  background: #e9f1fb;
}
.batch-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}
.batch-summary-card {
  border-color: #cdd8e3;
}
.batch-summary-card-active {
  border-color: #0b2d71;
  box-shadow: 0 0 0 1px #0b2d71 inset;
}
.batch-summary-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.batch-summary-title-row,
.batch-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.batch-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
}
.batch-summary-note {
  margin-bottom: 0;
}
.batch-editor-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.batch-status-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e8eef4;
  color: #0b2d71;
  font-size: 11px;
  font-weight: 700;
}
.batch-header-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 20px;
  margin-top: 10px;
}
.batch-header-grid > .form-row,
.batch-header-grid > .thickening-notes-row {
  margin-bottom: 0;
}
.batch-header-grid > .thickening-notes-row {
  grid-column: 1 / -1;
}
.batch-warning-banner,
.batch-tolerance-row {
  grid-column: 1 / -1;
}
.batch-mix-as-foam-panel {
  grid-column: 1 / -1;
  display: grid;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #d4dee8;
  border-radius: 4px;
  background: #f7fafc;
}
.batch-warning-banner {
  padding: 8px 10px;
  border: 1px solid #f3d38c;
  border-radius: 4px;
  background: #fff8e5;
  color: #8a5a00;
  font-size: 12px;
  font-weight: 700;
}
.batch-tolerance-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.batch-inline-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  font-weight: 600;
  color: #1c2d41;
}
.batch-measurement-grid {
  margin-bottom: 8px;
}
.batch-measurement-note {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 32px;
  justify-content: center;
}
.batch-foamer-picker {
  display: grid;
  gap: 8px;
}
.batch-foamer-picker-title {
  font-size: 12px;
  font-weight: 700;
  color: #1c2d41;
}
.batch-foamer-picker-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
}
.batch-test-selector {
  margin-bottom: 12px;
}
.batch-empty-note,
.batch-table-block {
  margin-bottom: 0;
}
.test-fixed-rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 0;
}
.test-fixed-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px 20px;
}
.test-fixed-row.cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.test-fixed-row.cols-1 {
  grid-template-columns: minmax(0, 1fr);
}
.test-fixed-row .form-row {
  display: grid;
  grid-template-columns: minmax(0, 190px) minmax(0, 170px);
  align-items: center;
  gap: 8px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;
}
.test-fixed-row .form-row > label {
  margin: 0;
  min-width: 0;
}
.test-fixed-row .form-row > .tab-input {
  width: 100%;
  max-width: 170px;
  min-width: 0;
  justify-self: stretch;
}
.test-fixed-row .form-row > label:only-child,
.test-fixed-row .form-row > button:only-child {
  grid-column: 1 / -1;
}
.test-fixed-row .form-row > button:only-child {
  justify-self: start;
}
.surface-wide-field .tab-input {
  max-width: 320px !important;
}
.surface-score-field .tab-input {
  width: 250px;
  max-width: 250px !important;
  justify-self: start !important;
}
.surface-score-field {
  grid-template-columns: minmax(0, 190px) minmax(250px, 250px) !important;
}
.surface-choice-row {
  grid-template-columns: 190px minmax(0, 1fr) !important;
  align-items: start !important;
}
.surface-choice-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding-top: 4px;
}
.surface-choice-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}
.surface-choice-option input {
  margin: 0;
}
.tests-section > .surface-section-body {
  container-type: inline-size;
}
@container (max-width: 1450px) {
  .legacy-test-card {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 1800px) {
  .legacy-test-card {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 1200px) {
  .test-fixed-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .thickening-schedule-grid {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
  .thickening-overview-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .batch-header-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .batch-foamer-picker-list {
    flex-direction: column;
    gap: 8px;
  }
}
@media (max-width: 900px) {
  .test-fixed-row,
  .test-fixed-row.cols-2 {
    grid-template-columns: minmax(0, 1fr);
  }
  .legacy-test-temperature-row > :first-child {
    display: none;
  }
  .compressive-test-card,
  .compressive-test-top {
    grid-template-columns: minmax(0, 1fr);
  }
  .compressive-test-type-row,
  .compressive-checkbox-row,
  .compressive-parameter-row,
  .test-checkbox-row,
  .surface-choice-row {
    grid-template-columns: minmax(0, 1fr) !important;
  }
  .test-fixed-row .form-row,
  .foam-notes-row,
  .thickening-notes-row,
  .legacy-test-actions,
  .thickening-actions {
    grid-template-columns: minmax(0, 1fr) !important;
  }
  .legacy-test-action-buttons,
  .thickening-actions-buttons {
    grid-column: auto;
  }
  .thickening-schedule-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .basic-info-field {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .basic-info-field .tab-input {
    width: 100%;
    max-width: 100%;
  }
  .test-fixed-row .form-row > .tab-input {
    width: 100%;
    max-width: 100%;
  }
  .thickening-output-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .batch-list,
  .batch-summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .batches-create-header,
  .batch-summary-title-row,
  .batch-editor-header {
    flex-direction: column;
  }
}
.test-section-title {
  font-size: 14px;
  font-weight: 700;
  margin: 14px 0 6px;
  border-bottom: 1px solid #cdd8e3;
  padding-bottom: 2px;
}
.test-section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}
.test-section-count {
  font-size: 12px;
  font-weight: 600;
  color: #587089;
}
.test-empty-card {
  display: flex;
  align-items: center;
  min-height: 48px;
  color: #587089;
}
.basic-info-field {
  display: grid;
  grid-template-columns: minmax(0, 190px) minmax(0, 170px);
  align-items: center;
  min-width: 0;
}
.basic-info-field .tab-input {
  width: 100%;
  max-width: 170px;
  min-width: 0;
  justify-self: stretch;
}
.single-test-dialog .single-test-dialog-note-field {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
}
.single-test-dialog .single-test-dialog-note-field .tab-input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
.thickening-main-title {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin: 4px 0 10px;
}
.thickening-block {
  border-top: 1px solid #d7e0ea;
  margin-bottom: 0;
}
.thickening-subsection {
  padding: 10px 10px;
}
.thickening-subtitle {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
}
.thickening-overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 1fr);
  gap: 10px;
  align-items: start;
}
.thickening-schedule-summary-row {
  grid-template-columns: 190px minmax(0, 1fr) !important;
  align-items: start !important;
}
.thickening-schedule-summary {
  min-height: 32px;
  padding-top: 6px;
  color: #2f3b47;
  line-height: 1.35;
  white-space: normal;
}
.thickening-detail-row,
.thickening-shutdown-row {
  grid-template-columns: 190px minmax(0, 1fr) !important;
  gap: 12px !important;
  align-items: start !important;
}
.thickening-toggle-label {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-weight: 600;
  width: -moz-fit-content;
  width: fit-content;
}
.thickening-detail-fields,
.thickening-shutdown-fields {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}
.thickening-inline-input {
  display: grid;
  grid-template-columns: 125px minmax(0, 1fr);
  gap: 8px;
  align-items: center;
  max-width: 320px;
}
.thickening-inline-input label {
  margin: 0;
  font-weight: 600;
}
.thickening-schedule-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 10px;
}
.schedule-card {
  border: 1px solid #d7e0ea;
  border-radius: 4px;
  padding: 8px;
  background: #fff;
}
.schedule-card-title {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}
.schedule-table {
  margin-bottom: 0;
}
.thickening-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.thickening-actions-buttons {
  display: flex;
  gap: 8px;
  min-width: 0;
  justify-content: flex-end;
  flex-wrap: wrap;
  grid-column: 2;
}
.thickening-notes-input {
  width: 100%;
  max-width: 100%;
}
.thickening-notes-row {
  grid-template-columns: 190px minmax(0, 1fr) !important;
  align-items: start !important;
}
.thickening-row-gap {
  margin-top: 6px;
}
.thickening-notes-row .tab-input {
  width: 100% !important;
  max-width: 100% !important;
}
.thickening-output-card {
  min-height: 100%;
}
.thickening-output-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.thickening-output-header .schedule-card-title {
  margin-bottom: 0;
}
.output-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.thickening-output-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
}
.thickening-output-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.thickening-output-label {
  font-size: 11px;
  font-weight: 700;
  color: #5f6f82;
  text-transform: uppercase;
}
.thickening-review-link {
  align-self: flex-start;
  font-size: 12px;
  margin-top: 4px;
  padding: 2px 8px !important;
}
.thickening-review-link::after {
  content: ' >';
}
.thickening-review-link[disabled] {
  color: #9aa7b6;
  pointer-events: none;
  text-decoration: none;
}
.test-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 6px;
  font-size: 11px;
}
.test-table th {
  background: #e8eef4;
  padding: 4px 6px;
  border: 1px solid #cdd8e3;
  text-align: left;
}
.test-table td {
  padding: 3px 4px;
  border: 1px solid #e0e8ee;
}
.test-num-input {
  width: 72px;
  padding: 2px 4px;
  border: 1px solid #b9c4d0;
  border-radius: 2px;
  font-size: 11px;
}
.test-footer {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.other-tests-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 8px 20px;
  margin-bottom: 16px;
}
.tab-note {
  color: #666;
  font-size: 0.85rem;
  margin-bottom: 12px;
}
.action-blocked-message {
  color: #b42318;
  font-size: 0.85rem;
  font-weight: 700;
}
.section-action-message {
  margin-bottom: 12px;
}
.note-action-message {
  margin-top: 8px;
}
.footer-action-message {
  flex-basis: 100%;
  margin-top: 4px;
}
.blocked-action-wrapper {
  display: inline-flex;
}
.blocked-action-wrapper.is-blocked {
  cursor: not-allowed;
}
.blocked-action-wrapper.is-blocked > button {
  pointer-events: none;
}

/* ── Checkbox / radio labels ── */
.checkbox-label {
  font-weight: 600;
}
.reason-options,
.compliance-tests {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.reason-option,
.compliance-test {
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-details/slurry-details.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA,yBAAyB,cAAc,EAAE;AACzC,kBAAkB,aAAa,EAAE,WAAW,EAAE;AAC9C,sBAAsB,WAAW,EAAE,gBAAgB,EAAE;;AAErD,mFAAmF;AACnF;EACE,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;AACA,gBAAgB,YAAY,EAAE;AAC9B,gBAAgB,YAAY,EAAE,kBAAkB,EAAE;AAClD,iBAAiB,YAAY,EAAE;AAC/B;;;;EAIE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kFAAkF;AACpF;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,mEAAmE;;AAEnE;;2EAE2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,MAAM;AACR;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA;;;EAGE,SAAS;EACT,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;;EAEE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,iEAAiE;EACjE,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mEAAmE;EACnE,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,uEAAuE;AACzE;AACA;EACE,sDAAsD;EACtD,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;AACA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;;IAEE,qCAAqC;EACvC;EACA;;;;;IAKE,gDAAgD;EAClD;EACA;;;;;IAKE,gDAAgD;EAClD;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;;IAEE,qCAAqC;EACvC;EACA;;;IAGE,sBAAsB;EACxB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,sDAAsD;EACtD,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,sDAAsD;EACtD,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,sDAAsD;EACtD,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,gBAAgB;AAClB","sourcesContent":[".slurry-details-container {\n  padding: 1rem;\n  min-height: 100vh;\n}\n.slurry-loading-wrap {\n  min-height: calc(100vh - 2rem);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.slurry-saving-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.6);\n  cursor: wait;\n}\n\ndiv.tabbed > ul.tabs > li.active-tab {\n  color: #0b2d71 !important;\n  font-weight: 600;\n  border-bottom: 4px solid #0b2d71;\n  padding-bottom: 0;\n}\n\ndiv.tabbed > ul.tabs {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n\n/* Breadcrumb parity with Slurry */\n.breadcrumb-row {\n  font-size: 13px;\n  margin-bottom: 10px;\n  color: #6B6D6F;\n}\n.breadcrumb-link {\n  color: #0066B2;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.breadcrumb-link:hover { color: #004080; }\n.breadcrumb-sep { margin: 0 4px; color: #888; }\n.breadcrumb-current { color: #333; font-weight: 600; }\n\n/* Read-only shell used for info tab parity without adding extra visual wrappers. */\n.surface-tab-stack[inert] {\n  opacity: 0.85;\n}\n\n/* ── Section blocks (navy header + white body) ── */\n.section {\n  background: white;\n  border: 1px solid #cdd8e3;\n  margin-bottom: 10px;\n}\n.section-header {\n  background: #0b2d71;\n  border-bottom: 1px solid #0b2d71;\n  padding: 6px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.section-title {\n  font-weight: 600;\n  color: #fff;\n  font-size: 15px;\n}\n.warning-icon {\n  background: #E5601F;\n  color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n/* ── Section body padding ── */\n.surface-section-body {\n  padding: 12px;\n}\n\n.surface-top-fields {\n  margin-bottom: 6px;\n}\n\n.surface-tab-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.surface-tab-stack .tests-section {\n  margin-bottom: 0;\n}\n\n.surface-divider {\n  border-top: 1px solid #d6d8db;\n  margin: 8px 0 16px;\n}\n\n.surface-notes-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.surface-notes-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* ── Delete button ── */\n.delete-btn {\n  color: #c0392b;\n  font-size: 18px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n/* ── Footer actions ── */\n.footer-actions {\n  padding: 1rem 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.5rem;\n}\n.footer-actions-main {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n.footer-actions-left,\n.footer-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n.footer-actions-right {\n  margin-left: auto;\n}\n.single-test-dialog-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 960;\n}\n.single-test-dialog {\n  width: 840px;\n  max-width: calc(100vw - 32px);\n  background: #fff;\n  border: 1px solid #cfd9e3;\n  border-radius: 4px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n}\n.single-test-dialog-header {\n  padding: 14px 16px 8px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0b2d71;\n}\n.single-test-dialog-body {\n  padding: 4px 16px 16px;\n}\n.single-test-dialog-field {\n  margin-bottom: 0;\n}\n.single-test-dialog-section {\n  margin-top: 12px;\n}\n.single-test-dialog-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 16px;\n  margin-top: 12px;\n}\n.single-test-basic-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 16px;\n}\n.single-test-dialog-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n}\n.single-test-dialog-span-2 {\n  grid-column: span 2;\n}\n.single-test-dialog-note-field {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n}\n.single-test-dialog-note-field > label {\n  width: 100%;\n}\n.single-test-dialog-note-field .tab-input {\n  width: 100%;\n  max-width: none;\n}\n.single-test-dialog-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #16355f;\n}\n.single-test-dialog-message {\n  margin-top: 12px;\n  color: #b42318;\n  font-size: 12px;\n}\n.single-test-dialog textarea.tab-input {\n  min-height: 76px;\n  resize: vertical;\n}\n.single-test-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n.single-test-dialog-footer {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  padding: 16px;\n  border-top: 1px solid #d7e0ea;\n}\n@media (max-width: 900px) {\n  .single-test-dialog-grid,\n  .single-test-basic-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .single-test-dialog-span-2 {\n    grid-column: span 1;\n  }\n\n  .single-test-dialog-note-field {\n    grid-column: span 1;\n  }\n}\n\n/* ── Blend / Liquid tables ── */\n.blend-section {\n  margin: 10px 12px;\n}\n.blend-header {\n  font-weight: 600;\n  color: #0b2d71;\n  font-size: 12px;\n  margin-bottom: 8px;\n  padding: 4px 0;\n}\n.blend-table,\n.liquid-table {\n  width: 100%;\n  font-size: 11px;\n  margin-bottom: 8px;\n  font-size: 11px;\n}\n.blend-table thead,\n.liquid-table thead {\n  background: #e8f4fd;\n  border: 1px solid #b8d6ec;\n}\n.blend-table th,\n.liquid-table th {\n  padding: 6px 8px;\n  text-align: center;\n  font-weight: 600;\n  color: #0b2d71;\n  border: 1px solid #cdd8e3;\n  font-size: 11px;\n  white-space: nowrap;\n}\n.blend-table td,\n.liquid-table td {\n  padding: 2px;\n  border: 1px solid #d0d0d0;\n  background: white;\n  text-align: center;\n}\n.blend-table td:has(input:not([readonly]), select:not([disabled])),\n.liquid-table td:has(input:not([readonly]), select:not([disabled])) {\n  background: #fff !important;\n}\n.blend-table td:has(input:not([readonly]), select:not([disabled])) input:not([readonly]),\n.blend-table td:has(input:not([readonly]), select:not([disabled])) select:not([disabled]),\n.liquid-table td:has(input:not([readonly]), select:not([disabled])) input:not([readonly]),\n.liquid-table td:has(input:not([readonly]), select:not([disabled])) select:not([disabled]) {\n  background: #fff;\n}\n.table-readonly-cell {\n  background: #f1f3f5 !important;\n}\n.blend-table td.table-readonly-cell input[readonly],\n.liquid-table td.table-readonly-cell input[readonly],\n.blend-table input[readonly],\n.liquid-table input[readonly] {\n  background: #f1f3f5;\n  color: #495057;\n}\n.col-material { width: 200px; }\n.col-numeric  { width: 100px; text-align: center; }\n.col-container { width: 180px; }\n.blend-base-table td,\n.blend-base-table .form-control,\n.blend-base-table .numeric-input,\n.blend-base-table .container-input {\n  text-align: center;\n}\n.material-cell {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.material-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n/* Inline table inputs */\n.material-select {\n  width: 100%;\n  padding: 3px 6px;\n  border: 1px solid #aaa;\n  font-size: 11px;\n  background: white;\n}\n.material-select.by-weight-select {\n  width: 65px;\n  padding: 2px 4px;\n}\n.numeric-input {\n  width: 100%;\n  padding: 3px 6px;\n  border: none;\n  font-size: 11px;\n  text-align: center;\n  box-sizing: border-box;\n}\n.container-input {\n  width: 100%;\n  padding: 3px 6px;\n  border: none;\n  font-size: 11px;\n  text-align: center;\n  box-sizing: border-box;\n}\n.table-container-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n.table-search-btn {\n  flex: 0 0 auto;\n  min-width: 42px;\n  padding: 2px 6px;\n  line-height: 1;\n}\n.table-edit-btn {\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.table-edit-btn:disabled {\n  cursor: not-allowed;\n}\n.cispro-display-input {\n  background: transparent;\n}\n.cispro-display-input[readonly] {\n  cursor: default;\n}\n.cispro-disposed-input,\n.blend-table input.cispro-disposed-input[readonly],\n.liquid-table input.cispro-disposed-input[readonly] {\n  border: 2px solid #dc0000;\n  border-radius: 3px;\n}\n.cispro-editor-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(7, 22, 44, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 950;\n}\n.cispro-editor-dialog {\n  width: 560px;\n  max-width: calc(100vw - 32px);\n  background: #fff;\n  border: 1px solid #cfd9e3;\n  border-radius: 4px;\n  box-shadow: 0 18px 40px rgba(9, 30, 66, 0.24);\n}\n.cispro-editor-header {\n  padding: 10px 16px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  background: #0b2d71;\n  border-bottom: 1px solid #0b2d71;\n}\n.cispro-editor-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.cispro-editor-intro {\n  color: #49627d;\n  font-size: 13px;\n}\n.cispro-editor-empty-note {\n  padding: 10px 12px;\n  border: 1px dashed #cfd9e3;\n  border-radius: 4px;\n  background: #f8fbff;\n  color: #5d728a;\n  font-size: 12px;\n}\n.cispro-editor-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.cispro-editor-field > label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #16355f;\n}\n.cispro-editor-row {\n  display: grid;\n  grid-template-columns: 1fr 40px 40px;\n  gap: 8px;\n  align-items: center;\n}\n.cispro-icon-btn {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #cfd9e3;\n  border-radius: 4px;\n  background: #fff;\n  padding: 0;\n  font-size: 18px;\n  line-height: 1;\n  color: #16355f;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n.cispro-icon-btn:hover {\n  background: #f3f7fc;\n  border-color: #9fb6d0;\n}\n.cispro-remove-btn {\n  color: #b42318;\n}\n.cispro-lookup-btn {\n  font-size: 20px;\n}\n.cispro-editor-input {\n  width: 100%;\n  height: 40px;\n  padding: 8px 12px;\n  border: 1px solid #b9c5d3;\n  border-radius: 4px;\n  background: #f8fbff;\n  color: #16355f;\n}\n.cispro-editor-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px;\n  border-top: 1px solid #d7e0ea;\n}\n\n@media (max-width: 640px) {\n  .cispro-editor-row {\n    grid-template-columns: 1fr;\n  }\n\n  .cispro-editor-footer {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\n/* ── Test tabs: settings grid, section titles, tables, inputs ── */\n\n/* .form-row / .tab-input are used only inside .test-settings-grid cells\n   for compact label-input pairs. They rely on the grid for column layout\n   and must NOT be used for main form rows (use Bootstrap row/col there). */\n.form-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 4px;\n}\n.form-row label {\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n  flex-shrink: 0;\n}\n.tab-input {\n  flex: 1;\n  min-width: 0;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.2rem;\n  font-family: 'GothamNarrowBook', sans-serif;\n}\n.tab-input-readonly,\n.tab-input[readonly] {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.test-settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 6px 20px;\n  margin-bottom: 14px;\n}\n.tests-section {\n  margin-bottom: 14px;\n}\n.tests-section-header {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n.tests-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  cursor: pointer;\n}\n.tests-toggle input {\n  margin: 0;\n}\n.test-row-card {\n  border: 1px solid #d7e0ea;\n  border-radius: 4px;\n  padding: 10px;\n  background: #fff;\n}\n.test-row-card + .test-row-card {\n  margin-top: 8px;\n}\n.legacy-test-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) minmax(260px, 1fr);\n  gap: 12px 24px;\n  align-items: start;\n}\n.legacy-test-main {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n.legacy-test-actions {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px 12px;\n  margin-top: 6px;\n}\n.legacy-test-muted-cell {\n  min-width: 0;\n}\n.legacy-test-muted-cell .test-fixed-row {\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0;\n}\n.legacy-test-muted-cell .legacy-test-muted-row {\n  margin-bottom: 0;\n}\n.legacy-test-action-buttons {\n  display: flex;\n  gap: 8px;\n  min-width: 0;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  grid-column: 2;\n}\n.legacy-test-muted-label,\n.legacy-test-actions .legacy-test-muted-row > label,\n.thickening-actions .legacy-test-muted-row > label {\n  margin: 0;\n  font-weight: 600;\n  font-family: 'GothamNarrowBold', sans-serif;\n}\n.legacy-test-muted-checkbox,\n.legacy-test-muted-row > input[type='checkbox'] {\n  justify-self: start;\n  margin: 0;\n}\n.legacy-test-muted-row {\n  display: grid;\n  grid-template-columns: 190px auto;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n.legacy-test-muted-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  margin: 0;\n  font-weight: 600;\n  justify-self: start;\n}\n.test-checkbox-row {\n  grid-template-columns: 190px auto !important;\n  gap: 8px !important;\n  align-items: center !important;\n}\n.test-checkbox-row > input[type='checkbox'],\n.compressive-checkbox-row > input[type='checkbox'] {\n  justify-self: start;\n  margin-left: 0;\n}\n.legacy-test-temperature-row {\n  margin-top: -2px;\n}\n.compressive-test-card {\n  grid-template-columns: minmax(0, 1.5fr) minmax(260px, 1fr);\n}\n.compressive-test-main {\n  gap: 10px;\n}\n.compressive-test-top {\n  display: grid;\n  grid-template-columns: minmax(240px, 0.95fr) minmax(300px, 1.1fr);\n  gap: 18px;\n  align-items: start;\n}\n.compressive-test-meta,\n.compressive-test-conditions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n.compressive-test-type-row {\n  grid-template-columns: minmax(0, 190px) minmax(0, 170px) !important;\n  gap: 8px !important;\n  align-items: center !important;\n}\n.compressive-checkbox-row {\n  grid-template-columns: 190px auto !important;\n  gap: 8px !important;\n  align-items: center !important;\n}\n.compressive-parameter-row {\n  display: grid;\n  grid-template-columns: minmax(0, 190px) minmax(0, 170px) !important;\n  gap: 8px;\n  align-items: center;\n  justify-content: start;\n}\n.compressive-parameter-row .tab-input {\n  width: 100% !important;\n  max-width: 170px !important;\n  min-width: 0;\n  justify-self: stretch;\n}\n.validated-test-input {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n.validated-test-input .tab-input {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.validation-input-invalid {\n  border-color: #c62828 !important;\n}\n.validation-inline-message {\n  margin: 0.35rem 0;\n  color: #c62828;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n.validation-field-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  border-radius: 50%;\n  background: #c62828;\n  color: #fff;\n  font-weight: 700;\n  line-height: 1;\n}\n.compressive-test-type-row > label,\n.compressive-parameter-row > label,\n.basic-info-field > label {\n  min-width: 0;\n}\n.compressive-notes-row {\n  margin-top: 2px;\n}\n.compressive-notes-row textarea.tab-input {\n  min-height: 64px;\n  resize: vertical;\n}\n.test-output-card {\n  min-height: 100%;\n}\n.hpht-group-card,\n.other-test-card,\n.batch-summary-card,\n.batch-editor-card {\n  margin-bottom: 10px;\n}\n.hpht-reading-card + .hpht-reading-card {\n  border-top: 1px solid #d7e0ea;\n  padding-top: 10px;\n}\n.hpht-reading-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n}\n.hpht-readings-label {\n  margin: 8px 0 4px;\n  font-weight: 600;\n}\n.foam-settings-action {\n  display: flex;\n  align-items: center;\n}\n.batches-create-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n.batches-create-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.batches-create-panel {\n  display: grid;\n  gap: 12px;\n}\n.batches-test-list {\n  display: grid;\n  gap: 6px;\n  max-width: 420px;\n}\n.batches-test-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  color: #1c2d41;\n}\n.batches-test-option input {\n  margin: 0;\n}\n.batches-existing-table-wrap {\n  overflow-x: auto;\n}\n.batches-existing-table {\n  width: 100%;\n}\n.batches-existing-row {\n  cursor: pointer;\n}\n.batches-existing-row td {\n  vertical-align: top;\n}\n.batches-existing-row:hover td {\n  background: #f7fafc;\n}\n.batches-existing-row-selected td {\n  background: #e9f1fb;\n}\n.batch-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.batch-summary-card {\n  border-color: #cdd8e3;\n}\n.batch-summary-card-active {\n  border-color: #0b2d71;\n  box-shadow: 0 0 0 1px #0b2d71 inset;\n}\n.batch-summary-main {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.batch-summary-title-row,\n.batch-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n.batch-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 14px;\n}\n.batch-summary-note {\n  margin-bottom: 0;\n}\n.batch-editor-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.batch-status-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #e8eef4;\n  color: #0b2d71;\n  font-size: 11px;\n  font-weight: 700;\n}\n.batch-header-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 20px;\n  margin-top: 10px;\n}\n.batch-header-grid > .form-row,\n.batch-header-grid > .thickening-notes-row {\n  margin-bottom: 0;\n}\n.batch-header-grid > .thickening-notes-row {\n  grid-column: 1 / -1;\n}\n.batch-warning-banner,\n.batch-tolerance-row {\n  grid-column: 1 / -1;\n}\n.batch-mix-as-foam-panel {\n  grid-column: 1 / -1;\n  display: grid;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid #d4dee8;\n  border-radius: 4px;\n  background: #f7fafc;\n}\n.batch-warning-banner {\n  padding: 8px 10px;\n  border: 1px solid #f3d38c;\n  border-radius: 4px;\n  background: #fff8e5;\n  color: #8a5a00;\n  font-size: 12px;\n  font-weight: 700;\n}\n.batch-tolerance-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n.batch-inline-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 32px;\n  font-weight: 600;\n  color: #1c2d41;\n}\n.batch-measurement-grid {\n  margin-bottom: 8px;\n}\n.batch-measurement-note {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 32px;\n  justify-content: center;\n}\n.batch-foamer-picker {\n  display: grid;\n  gap: 8px;\n}\n.batch-foamer-picker-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1c2d41;\n}\n.batch-foamer-picker-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 16px;\n}\n.batch-test-selector {\n  margin-bottom: 12px;\n}\n.batch-empty-note,\n.batch-table-block {\n  margin-bottom: 0;\n}\n.test-fixed-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 0;\n}\n.test-fixed-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px 20px;\n}\n.test-fixed-row.cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.test-fixed-row.cols-1 {\n  grid-template-columns: minmax(0, 1fr);\n}\n.test-fixed-row .form-row {\n  display: grid;\n  grid-template-columns: minmax(0, 190px) minmax(0, 170px);\n  align-items: center;\n  gap: 8px;\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n}\n.test-fixed-row .form-row > label {\n  margin: 0;\n  min-width: 0;\n}\n.test-fixed-row .form-row > .tab-input {\n  width: 100%;\n  max-width: 170px;\n  min-width: 0;\n  justify-self: stretch;\n}\n.test-fixed-row .form-row > label:only-child,\n.test-fixed-row .form-row > button:only-child {\n  grid-column: 1 / -1;\n}\n.test-fixed-row .form-row > button:only-child {\n  justify-self: start;\n}\n.surface-wide-field .tab-input {\n  max-width: 320px !important;\n}\n.surface-score-field .tab-input {\n  width: 250px;\n  max-width: 250px !important;\n  justify-self: start !important;\n}\n.surface-score-field {\n  grid-template-columns: minmax(0, 190px) minmax(250px, 250px) !important;\n}\n.surface-choice-row {\n  grid-template-columns: 190px minmax(0, 1fr) !important;\n  align-items: start !important;\n}\n.surface-choice-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  padding-top: 4px;\n}\n.surface-choice-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n.surface-choice-option input {\n  margin: 0;\n}\n.tests-section > .surface-section-body {\n  container-type: inline-size;\n}\n@container (max-width: 1450px) {\n  .legacy-test-card {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 1800px) {\n  .legacy-test-card {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 1200px) {\n  .test-fixed-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .thickening-schedule-grid {\n    grid-template-columns: repeat(2, minmax(180px, 1fr));\n  }\n  .thickening-overview-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .batch-header-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .batch-foamer-picker-list {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n@media (max-width: 900px) {\n  .test-fixed-row,\n  .test-fixed-row.cols-2 {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .legacy-test-temperature-row > :first-child {\n    display: none;\n  }\n  .compressive-test-card,\n  .compressive-test-top {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .compressive-test-type-row,\n  .compressive-checkbox-row,\n  .compressive-parameter-row,\n  .test-checkbox-row,\n  .surface-choice-row {\n    grid-template-columns: minmax(0, 1fr) !important;\n  }\n  .test-fixed-row .form-row,\n  .foam-notes-row,\n  .thickening-notes-row,\n  .legacy-test-actions,\n  .thickening-actions {\n    grid-template-columns: minmax(0, 1fr) !important;\n  }\n  .legacy-test-action-buttons,\n  .thickening-actions-buttons {\n    grid-column: auto;\n  }\n  .thickening-schedule-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .basic-info-field {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n  .basic-info-field .tab-input {\n    width: 100%;\n    max-width: 100%;\n  }\n  .test-fixed-row .form-row > .tab-input {\n    width: 100%;\n    max-width: 100%;\n  }\n  .thickening-output-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .batch-list,\n  .batch-summary-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .batches-create-header,\n  .batch-summary-title-row,\n  .batch-editor-header {\n    flex-direction: column;\n  }\n}\n.test-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  margin: 14px 0 6px;\n  border-bottom: 1px solid #cdd8e3;\n  padding-bottom: 2px;\n}\n.test-section-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n}\n.test-section-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: #587089;\n}\n.test-empty-card {\n  display: flex;\n  align-items: center;\n  min-height: 48px;\n  color: #587089;\n}\n.basic-info-field {\n  display: grid;\n  grid-template-columns: minmax(0, 190px) minmax(0, 170px);\n  align-items: center;\n  min-width: 0;\n}\n.basic-info-field .tab-input {\n  width: 100%;\n  max-width: 170px;\n  min-width: 0;\n  justify-self: stretch;\n}\n.single-test-dialog .single-test-dialog-note-field {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  width: 100%;\n}\n.single-test-dialog .single-test-dialog-note-field .tab-input {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n.thickening-main-title {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 4px 0 10px;\n}\n.thickening-block {\n  border-top: 1px solid #d7e0ea;\n  margin-bottom: 0;\n}\n.thickening-subsection {\n  padding: 10px 10px;\n}\n.thickening-subtitle {\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n.thickening-overview-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 1fr);\n  gap: 10px;\n  align-items: start;\n}\n.thickening-schedule-summary-row {\n  grid-template-columns: 190px minmax(0, 1fr) !important;\n  align-items: start !important;\n}\n.thickening-schedule-summary {\n  min-height: 32px;\n  padding-top: 6px;\n  color: #2f3b47;\n  line-height: 1.35;\n  white-space: normal;\n}\n.thickening-detail-row,\n.thickening-shutdown-row {\n  grid-template-columns: 190px minmax(0, 1fr) !important;\n  gap: 12px !important;\n  align-items: start !important;\n}\n.thickening-toggle-label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  font-weight: 600;\n  width: fit-content;\n}\n.thickening-detail-fields,\n.thickening-shutdown-fields {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n}\n.thickening-inline-input {\n  display: grid;\n  grid-template-columns: 125px minmax(0, 1fr);\n  gap: 8px;\n  align-items: center;\n  max-width: 320px;\n}\n.thickening-inline-input label {\n  margin: 0;\n  font-weight: 600;\n}\n.thickening-schedule-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(180px, 1fr));\n  gap: 10px;\n}\n.schedule-card {\n  border: 1px solid #d7e0ea;\n  border-radius: 4px;\n  padding: 8px;\n  background: #fff;\n}\n.schedule-card-title {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n.schedule-table {\n  margin-bottom: 0;\n}\n.thickening-actions {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n.thickening-actions-buttons {\n  display: flex;\n  gap: 8px;\n  min-width: 0;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  grid-column: 2;\n}\n.thickening-notes-input {\n  width: 100%;\n  max-width: 100%;\n}\n.thickening-notes-row {\n  grid-template-columns: 190px minmax(0, 1fr) !important;\n  align-items: start !important;\n}\n.thickening-row-gap {\n  margin-top: 6px;\n}\n.thickening-notes-row .tab-input {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n.thickening-output-card {\n  min-height: 100%;\n}\n.thickening-output-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n.thickening-output-header .schedule-card-title {\n  margin-bottom: 0;\n}\n.output-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n.thickening-output-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 14px;\n}\n.thickening-output-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.thickening-output-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #5f6f82;\n  text-transform: uppercase;\n}\n.thickening-review-link {\n  align-self: flex-start;\n  font-size: 12px;\n  margin-top: 4px;\n  padding: 2px 8px !important;\n}\n.thickening-review-link::after {\n  content: ' >';\n}\n.thickening-review-link[disabled] {\n  color: #9aa7b6;\n  pointer-events: none;\n  text-decoration: none;\n}\n.test-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 6px;\n  font-size: 11px;\n}\n.test-table th {\n  background: #e8eef4;\n  padding: 4px 6px;\n  border: 1px solid #cdd8e3;\n  text-align: left;\n}\n.test-table td {\n  padding: 3px 4px;\n  border: 1px solid #e0e8ee;\n}\n.test-num-input {\n  width: 72px;\n  padding: 2px 4px;\n  border: 1px solid #b9c4d0;\n  border-radius: 2px;\n  font-size: 11px;\n}\n.test-footer {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.other-tests-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 8px 20px;\n  margin-bottom: 16px;\n}\n.tab-note {\n  color: #666;\n  font-size: 0.85rem;\n  margin-bottom: 12px;\n}\n.action-blocked-message {\n  color: #b42318;\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n.section-action-message {\n  margin-bottom: 12px;\n}\n.note-action-message {\n  margin-top: 8px;\n}\n.footer-action-message {\n  flex-basis: 100%;\n  margin-top: 4px;\n}\n.blocked-action-wrapper {\n  display: inline-flex;\n}\n.blocked-action-wrapper.is-blocked {\n  cursor: not-allowed;\n}\n.blocked-action-wrapper.is-blocked > button {\n  pointer-events: none;\n}\n\n/* ── Checkbox / radio labels ── */\n.checkbox-label {\n  font-weight: 600;\n}\n.reason-options,\n.compliance-tests {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.reason-option,\n.compliance-test {\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
